import React, { useEffect, useState } from "react";
import { Input, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import TableWithDynamicPagination from "../../table/table";
import { debounce, map, sortBy, filter } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
import { formatDisplayDate } from "@utils/helpers";
// import "../matchingRecordsTable/matchingRecordsTable.scss";
import ExtraDetailsOfUser from "../../interventionCases/detailsOfUser/detailsOfUser";
import moment from "moment";

const { Search } = Input;

const SearchRecordsOfEMPI = (props: { columnsNeedToShowInSearchTable: any; columnsNeedToShowInSearchPopUp: any; setTarget: any; sourceEmpiId: any }) => {
  const [columnList, setColumnList] = useState<any>([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchedString, setSearchedString] = useState<any>(null);
  const columnsNeedToShowInTable = props.columnsNeedToShowInSearchTable;
  const columnsNeedToShowInPopUp = props.columnsNeedToShowInSearchPopUp;

  useEffect(() => {
    let _columns = map(columnsNeedToShowInTable, (item) => {
      if (item.key === "action_desc" || item.key === "action") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          render: (value: any, record: any) => {
            return (
              <div className="ui-empi-matching-records__table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={columnsNeedToShowInPopUp} />
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else if (item.key === "member_empi_key") {
        return { width: "20%", title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      } else {
        return { ellipsis: true, title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    setColumnList(_columns);
  }, [columnsNeedToShowInPopUp, columnsNeedToShowInTable, props]);

  const fetchData = async (payload: any) => {
    console.log("ExpandableTable.fetchData.");
    setLoadingSearch(true);

    try {
      const _data: any = await axios
        .post(`${sessionService.getClient()?.appServiceUrl}/empi/search-records`, { ...payload, payerName: undefined, groupId: undefined, searchValue: searchedString })
        .then((response) => {
          return response.data.data.records;
        });
      setLoadingSearch(false);

      return {
        totalCount: _data?.count,

        // source itself should not be searchable, so filtering it out
        data: filter(_data?.empiRecords, (item) => {
          return item.member_empi_key !== props.sourceEmpiId;
        }),
      };
    } catch (e) {
      setLoadingSearch(false);
      return { totalCount: 0, data: [] };
    }
  };

  return (
    <>
      <div className="ui-empi-matching-records">
        <Spin spinning={loadingSearch} indicator={<></>}>
          <p className="ui-empi-matching-records__warning">
            Use this search bar to search EMPI, First Name, Last Name and DOB(MM-DD-YYYY) separated by <b>semi-colon</b> (<b>;</b>). Please refer the example in the placeholder.{" "}
          </p>
          <Search
            autoFocus={true}
            size="large"
            className="ui-empi-matching-records__search"
            placeholder="e.g. John ; Wick ; MM-DD-YYYY"
            loading={loadingSearch}
            onChange={debounce((e) => {
              let x = filter(e?.target?.value.split(";"), (item) => {
                return !!item.trim();
              })?.join(";");

              var dateType = /^(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])-\d{4}$/;
              x = map(x.split(";"), (item) => {
                return dateType.test(item.trim()) ? moment(item).format("YYYY-MM-DD") : item;
              })?.join(";");

              setSearchedString(x);
            }, 1000)}
            prefix={<SearchOutlined />}
          />
        </Spin>
        <TableWithDynamicPagination
          key={`${searchedString?.length >= 3}`}
          dependencyPropsForPage1={searchedString}
          condition={searchedString?.length >= 3}
          className={"ui-empi-matching-records__table"}
          columns={columnList}
          handleFetchData={fetchData}
          columnOriginalList={columnsNeedToShowInTable}
          scrollProp={{ y: window.innerHeight - 590 }}
          rowSelectionNeeded={true}
          rowSelectionType={"radio"}
          rowKey={"member_unique_id"}
          handleRowSelection={(selectedRow: any) => props.setTarget(selectedRow)}
        />
      </div>
    </>
  );
};

export default SearchRecordsOfEMPI;
